/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useRef, useContext } from "react";
import { ChannelPopup } from "components/channel-popup/channel-popup";
// import context from "core/tv-guide.context";
import { observer } from "mobx-react-lite";
import { AppContext } from "core/providers/tv-guide.context";
import ChannelItem from "./channel-item";

const SidePanel = observer((props: any) => {

  const appContext = useContext(AppContext);
  const store = appContext.store;

  const [channels, setChannels] = useState<any>([]);
  const sidePanelEl = useRef<any>(null);
  const [scrollY, setScrollY] = useState(0);
  const [grabbing, setGrabbing] = useState(false);

  const toggleFavourite = (channelNumber: number) => {
    let favourites = store.favouriteChannelNumbers;

    if (favourites.includes(channelNumber)) {
      favourites = favourites.filter(x => x !== channelNumber);
    } else {
      favourites.push(channelNumber);
    }

    store.updateFavouriteChannelNumbers(favourites);
  }

  if (
    sidePanelEl.current &&
    props.scrollY !== undefined &&
    props.scrollY !== scrollY
  ) {
    sidePanelEl.current.scrollTo(0, props.scrollY, {
      behavior: "smooth",
    });
  }

  const isFavourite = (number: number) => store.hasFavourites && store.favouriteChannelNumbers.includes(number);

  const checkFavourite = (number: number) => {
    return isFavourite(number)
      ? "button btn-fav icon-star_full star"
      : "button btn-fav icon-star_outline star";
  }

  useEffect(() => {
    const options = { parentClassName: "gridSidePanel", targetClassName: "open-popup" };
    ChannelPopup.Create(store, options);
  }, []);


  useEffect(() => {
    if (!store.hasScheduleData) {
      return;
    }

    const channels = store.showFavourites
      ? store.favouriteChannelNumbers
      : store.channelNumbers;

    setChannels(channels);

  }, [store.channelNumbers, store.favouriteChannelNumbers, store.hasScheduleData, store.showFavourites]);

  return (
    <div
      className="grid-side-panel grabbable"
      id="gridSidePanel"
      ref={sidePanelEl}
      onMouseDown={() => {
        if (!grabbing) {
          setGrabbing(true);
        }
      }}
      onMouseMove={(ev) => {
        if (grabbing) {
          sidePanelEl.current.scrollBy(-ev.movementX, -ev.movementY);
        }
      }}
      onMouseLeave={() => {
        if (grabbing) {
          setGrabbing(false);
        }
      }}
      onMouseUp={() => {
        if (grabbing) {
          setGrabbing(false);
        }
      }}
      onScroll={(ev: any) => {
        setScrollY(ev.target.scrollTop);
        props.setScrollY(ev.target.scrollTop);
      }}
    >
      {/* Grab the first result to set all channels */}
      {channels.length &&
        channels.map((channelNumber: number, index: number) => <ChannelItem
          key={"ch-" + channelNumber}
          channelNumber={channelNumber}
          toggleFavourite={toggleFavourite}
          checkFavourite={checkFavourite}
          index={index} />)}

      <div className="channel-shadow">
      </div>
    </div>
  );
});

export default SidePanel;
